import { Col, Container, Row } from "reactstrap"
import Toggle from "../../../../components/common/Toggle/Toggle"
import DatatableComponent from "../../../../components/common/DatatableComponent/DatatableComponent"
import Checkbox from "../../../../components/common/Checkbox/Checkbox"
import CustomDropdown from "../../../../components/common/Dropdown/CustomDropDown"
import YellowHeaderWrapper from "../../../../components/common/YellowHeaderWrapper/YellowHeaderWrapper"

const Notification = () => {
  const data = [
    { notificationType: "Order Updates" },
    { notificationType: "Account Alerts" },
    { notificationType: "Promotional Offers" },
    { notificationType: "News & Updates" },
    { notificationType: "Transaction" },
  ]

  const columns = [
    { name: "Type", selector: (row) => row.notificationType },
    { name: "Email", cell: () => <Checkbox />, center: true },
    { name: "SMS", cell: () => <Checkbox />, center: true },
    { name: "Push Notifications", cell: () => <Checkbox />, center: true },
    { name: "In-app Notification", cell: () => <Checkbox />, center: true },
  ]

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100vh", paddingBlock: "1rem" }}>
      <Container fluid>
        <div className="fw-semibold fs-4 mb-3">Notification</div>

        <YellowHeaderWrapper title={"Notification Channels"}>
          <Row className="g-0 align-items-center">
            <Col sm='6' md="4">Two-factor Verification:</Col>
            <Col sm='6' md="6">
              <Toggle />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col sm='6' md="4">SMS notification:</Col>
            <Col sm='6' md="6">
              <Toggle />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col sm='6' md="4">Push notification:</Col>
            <Col sm='6' md="6">
              <Toggle />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col sm='6' md="4">In-app notification:</Col>
            <Col sm='6' md="6">
              <Toggle />
            </Col>
          </Row>
        </YellowHeaderWrapper>

        <YellowHeaderWrapper title={"Notification Types"}>
          <Row className="g-0 align-items-center">
            <Col sm='6' md="4">Order Updates: </Col>
            <Col sm='6' md="6">
              <Toggle />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col sm='6' md="4">Account Alerts:</Col>
            <Col sm='6' md="6">
              <Toggle />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col sm='6' md="4">Promotional Offers:</Col>
            <Col sm='6' md="6">
              <Toggle />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col sm='6' md="4">News and Updates:</Col>
            <Col sm='6' md="6">
              <Toggle />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col sm='6' md="4">Transaction Alerts:</Col>
            <Col sm='6' md="6">
              <Toggle />
            </Col>
          </Row>
        </YellowHeaderWrapper>

        <YellowHeaderWrapper title={"Customization"}>
          <DatatableComponent data={data} columns={columns} type={"gray"} />
        </YellowHeaderWrapper>

        <YellowHeaderWrapper title={"Notification Timing"}>
          <Row className="g-0">
            <Col xs="4" lg='2'>Delivery time:</Col>
            <Col xs="6" lg='4'>
              <div className="d-flex align-items-center gap-1">
                <Checkbox /> <span>Immediately (as soon as the event occurs)</span>
              </div>
              <div className="d-flex align-items-center gap-1">
                <Checkbox /> <span>Daily summary (once a day at a specified time)</span>
              </div>
              <div className="d-flex align-items-center gap-1">
                <Checkbox /> <span>Weekly summary (once a week at a specified day and time)</span>
              </div>
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs="4" lg='2'>Preferred time:</Col>
            <Col xs="6" lg='4'>
              <div className="border border-subtle-secondary rounded p-2">
                <CustomDropdown title={"Choose from dropdown menu"} muted />
              </div>
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs="4" lg='2'>Time zone:</Col>
            <Col xs="6" lg='4'>
              <div className="border border-subtle-secondary rounded p-2">
                <CustomDropdown title={"Choose from dropdown menu"} muted />
              </div>
            </Col>
          </Row>
        </YellowHeaderWrapper>
      </Container>
    </div>
  )
}

export default Notification
